export const BOTTOM_NAV_HEIGHT = 68;

export const WAITING_PAYMENT_STICKY_HEIGHT = 64;

export const WAITING_PAYMENT_STICKY_MOBILE_BOTTOM = BOTTOM_NAV_HEIGHT;

export const WAITING_PAYMENT_STICKY_MOBILE_SPACER =
  WAITING_PAYMENT_STICKY_HEIGHT + BOTTOM_NAV_HEIGHT;

export type BuyerBottomNavItemId =
  | 'home'
  | 'orders'
  | 'recipes'
  | 'shopping-list'
  | 'account';

export interface BuyerBottomNavItem {
  id: BuyerBottomNavItemId;
  label: string;
  href: string;
  showNewBadge?: boolean;
  showAccountDot?: boolean;
}

export const BUYER_BOTTOM_NAV_ITEMS: readonly BuyerBottomNavItem[] = [
  {
    id: 'home',
    label: 'Beranda',
    href: '/',
  },
  {
    id: 'orders',
    label: 'Pesanan',
    href: '/my-order?page=1&search=',
  },
  {
    id: 'recipes',
    label: 'Resep',
    href: '/recipes',
    showNewBadge: true,
  },
  {
    id: 'shopping-list',
    label: 'Daftar Belanja',
    href: '/daftar-belanja?page=1&search=',
  },
  {
    id: 'account',
    label: 'Akun',
    href: '/profile',
    showAccountDot: true,
  },
] as const;

export function shouldShowBuyerBottomNav(pathname: string): boolean {
  if (pathname === '/' || pathname === '/my-order') {
    return true;
  }

  if (pathname === '/recipes' || pathname === '/recipes/favorite') {
    return true;
  }

  if (pathname === '/daftar-belanja' || pathname.startsWith('/daftar-belanja/')) {
    return true;
  }

  if (pathname === '/profile' || pathname.startsWith('/profile/')) {
    return true;
  }

  return false;
}

export function getActiveBuyerBottomNavId(
  pathname: string
): BuyerBottomNavItemId | null {
  if (!shouldShowBuyerBottomNav(pathname)) {
    return null;
  }

  if (pathname === '/') {
    return 'home';
  }

  if (pathname === '/my-order') {
    return 'orders';
  }

  if (pathname === '/recipes' || pathname.startsWith('/recipes/')) {
    return 'recipes';
  }

  if (
    pathname === '/daftar-belanja' ||
    pathname.startsWith('/daftar-belanja/')
  ) {
    return 'shopping-list';
  }

  if (pathname === '/profile' || pathname.startsWith('/profile/')) {
    return 'account';
  }

  return null;
}
